<template lang="pug">
  .form-wrapper
    .row(v-for="row1 in form_block.visible_attributes().eachSlice(2)")
      .form-col.large-12(v-for="attr in row1")
        Field(
          :attr="attr",
          :form_block="form_block",
          :disabled="!fullEntitySelected"
          v-model="tmpEntityAttrs[attr]"
          :required="form_block.required_attrs.includes(attr)"
          @requiredInput="requiredInput"
          @change="$emit('entity_attrs:input',tmpEntityAttrs)"
        )
    .row(v-for="row1 in form_block.custom_fields.eachSlice(2)")
      .form-col.large-12(v-for="cf in row1" :set="setDefaultCustom(tmpCustomAttrs, cf)")
        CustomField(
          v-model="tmpCustomAttrs[cf.id]"
          :required="form_block.required_custom_field_ids.includes(cf.id)",
          :custom_field="cf",
          :entity_selected="fullEntitySelected"
          @change="$emit('custom_attrs:input',tmpCustomAttrs)"
        )
    .clearfix

    member-field(
      v-model="tmpMemberAttrs"
      v-if="form_block.membership_id"
      :entity-selected="fullEntitySelected"
      :required="form_block.membership_id_required"
      :description="form_block.membership_id_desc"
      @change="$emit('member_attrs:input',tmpMemberAttrs)"
    )
</template>

<script>
  import Field from "../form_block/_field"
  import CustomField from "../form_block/_custom_field"
  import MemberField from "../form_block/_member_field"
  import {FormBlock} from "../../../models/form_block";

  export default {
    name: "FormBlockContent",
    components: {Field,CustomField,MemberField},
    props: {
      form_block: new FormBlock(),
      entity_selected: {type: Boolean, default: false},
      entity_attrs: {type: Object, },
      custom_attrs: {type: Object, },
      member_attrs: {type: Object, },
    },
    emits: {
      'entity_attrs:input': {},
      'custom_attrs:input': {},
      'member_attrs:input': {},
      requiredInput: {},
    },
    data:()=>({
      tmpEntityAttrs: {},
      tmpCustomAttrs: {},
      tmpMemberAttrs: {},
    }),
    watch: {
      entity_attrs(val){this.tmpEntityAttrs = val||{} },
      custom_attrs(val){this.tmpCustomAttrs = val||{} },
      member_attrs(val){this.tmpMemberAttrs = val||{} },
    },
    computed: {
      fullEntitySelected(){
        return this.entity_selected || this.tmpEntityAttrs.id!=null
      },
    },
    created(){
      this.tmpEntityAttrs = this.entity_attrs
      this.tmpCustomAttrs = this.custom_attrs
      this.tmpMemberAttrs = this.member_attrs
    },
    methods: {
      requiredInput(evt, ...attrs){console.log(evt, ...attrs); this.$emit('requiredInput', evt, ...attrs) },
      setDefaultCustom(tmpCustomAttrs, cf){
        tmpCustomAttrs[cf.id]|| this.$set(tmpCustomAttrs, cf.id, [])
      },
    }
  }
</script>

<style lang="scss" scoped>
  .hidden {
    visibility: hidden;
    position: absolute;
    left: -9999px;
  }
  .field.hidden1{
    position: static;
  }
</style>